<template lang="pug">
.container-layout-padrao
  Nav
  .pagina-atual
    .pagina {{ $route.name === 'Perfil' ? 'Perfil Desenvolvedor' : $route.name === 'InformacoesPessoais' ? 'Editar Perfil' : $route.name === 'TopHabilidades' ? 'Editar Perfil' : $route.name === 'OutrasHabilidades' ? 'Editar Perfil' : $route.name }}
    ButtonPadrao(
      v-if="$route.name !== 'Perfil'"
      @click="$router.push('/espaco-nexa/perfil')"
      variant="negative"
    ) Voltar ao Perfil
  .router-view
    router-view
</template>

<script>
import { mapActions } from 'vuex';
import Nav from '@/components/Nav.vue'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue';

export default {
  components: {
    Nav,
    ButtonPadrao
  },

  created() {
    this.fetchExpertises()
    this.fetchSkills()
    this.fetchPermissoes()
    this.fetchUsuarios()
    this.fetchClasses()
  },

  methods: {
    ...mapActions({
      fetchExpertises: 'expertises/fetchExpertises',
      fetchSkills: 'habilidades/fetchSkills',
      fetchPermissoes: 'permissoes/fetchPermissoes',
      fetchUsuarios: 'usuario/fetchUsuarios',
      fetchClasses: 'classes/fetchClasses'
    })
  },
}

</script>

<style lang="scss">
.container-layout-padrao {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $corPreto;
  color: $corBranco;
  margin: 0 auto;
  padding: 0 16px 60px 16px;
  box-sizing: border-box;
  overflow: auto;

  .pagina-atual{
    max-width: 1360px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 120px 0 32px 0;

    .pagina{
      font-size: 30px;
      font-weight: 700;
      color: $corVerdeClaro;
    }
  }
  
  .router-view{
    max-width: 1360px;
    width: 100%;
  }
}

.container-layout-padrao, .container-layout-padrao * {
  font-family: "Inter", sans-serif !important;
}

@media (max-width: 768px) {
  .container-layout-padrao {
    .pagina-atual {
      margin-top: 20px;
    }
    padding-bottom: 100px;
  }
}
</style>